import { render, staticRenderFns } from "./PetsPlans360Tab.vue?vue&type=template&id=496c0468&scoped=true&"
import script from "./PetsPlans360Tab.vue?vue&type=script&lang=js&"
export * from "./PetsPlans360Tab.vue?vue&type=script&lang=js&"
import style0 from "./PetsPlans360Tab.vue?vue&type=style&index=0&id=496c0468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c0468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VIcon,VSkeletonLoader})
